var map = {
	"./flopmachine_en.png": "6WkA",
	"./flopmachine_th.png": "Y1MJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8Omv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas ^\.\/flopmachine_.*\.png$
// module id = 8Omv
// module chunks = 1